<template>
  <div class="MobileNavigation">
    <div
      @click="$emit('change', el)"
      class="MobileNavigation__item"
      v-for="el in elements"
      :key="el"
      :class="{ 'MobileNavigation__item--active': active === el }"
    >
      {{ el }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileNavigation',
  props: {
    elements: Object,
    active: String,
  },
}
</script>

<style lang="scss">
.MobileNavigation {
  display: none;
  margin: 35px 0 10px;

  @include mobile {
    display: flex;
  }

  &__item {
    position: relative;
    padding-top: 10px;
    margin: 0 10px;
    font-weight: 700;
    font-size: 15px;
    line-height: 20px;
    color: $dark;
    cursor: pointer;
    user-select: none;

    &:first-child {
      margin-left: 0;
    }

    &--active {
      color: $text;
      &::after {
        content: '';
        position: absolute;
        bottom: 100%;
        left: 0;
        right: 0;
        height: 3px;
        border-radius: 3px;
        background: $primary;
      }
    }
  }
}
</style>
